module.exports = __webpack_public_path__ + "img/login-bg.4cc435d6.png";